<template>
  <span>
    <span
      v-if="lowestPriorPrice?.withTax"
      class="text-gray-500 text-sm font-normal"
    >
      {{ $t('price.lowest_prior_price') }}
      {{ toCurrency(lowestPriorPrice.withTax) }}
    </span>
    <span
      v-if="lowestPriorPrice?.relativeDifferenceToPrice != null"
      class="text-gray-500 text-sm font-normal"
    >
      ({{ formattedRelativeDifferencePercent }}%)
    </span>
  </span>
</template>
<script setup lang="ts">
import type { LowestPriorPrice } from '@scayle/storefront-nuxt'

const props = defineProps<{
  lowestPriorPrice?: LowestPriorPrice
}>()

const formattedRelativeDifferencePercent = computed(() => {
  const diff = props.lowestPriorPrice?.relativeDifferenceToPrice
  if (diff == null) return '' // no data → show nothing

  const diffPercent = Math.round(diff * 100)

  if (diffPercent === 0) return '0'
  if (diffPercent > 0) return `+${diffPercent}`
  return `${diffPercent}`
})
</script>
